import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { DependencyModel, DependencyRegistrableEntityModel } from '@data-layer/models/dependencies';
import { ManagementEventModel } from '../models/management/management-event-model';
import { PaginatedResultModel } from '../models/common';

@Injectable({
  providedIn: 'root',
})
export class DependencyManagementRepository {
  constructor(private apiService: ApiService) {}

  public getDependenciesForCompany(companyId: number, isUsed: boolean = false): Observable<DependencyModel[]> {
    return this.apiService.get<DependencyModel[]>(
      `${environment.url.prefixCustoms}v2/management/companies/${companyId}/dependencies`,
      null,
      {
        isUsed,
      },
    );
  }

  public getDependencyEvents(dependencyId: number, isShowLoader: boolean = true): Observable<PaginatedResultModel<ManagementEventModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementEventModel>>(
      `${environment.url.prefixCustoms}v2/management/dependencies/${dependencyId}/events`,
      null,
      {
        isShowLoader,
        isUsed: true,
      },
    );
  }

  public registerImporterForCompany(companyId: number, entity: DependencyRegistrableEntityModel): Observable<never> {
    return this.apiService.post(`${environment.url.companiesManagement}${companyId}/registered-importers`, entity);
  }
}
